import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { AppAutocomplete } from "./app-autocomplete/app-autocomplete.tsx";
import { AutocompleteProvider } from "./app-autocomplete/providers/AutocompleteProvider.tsx";
import {ConfigProvider} from "./ConfigProvider.tsx";

const rootElements = document.querySelectorAll<HTMLElement>('#algolia-autocomplete');

rootElements.forEach((rootElement) => {
	const rootNode = createRoot(rootElement);
	rootNode.render(
		<StrictMode>
			<ConfigProvider domElement={rootElement}>
				<AutocompleteProvider>
					<AppAutocomplete />
				</AutocompleteProvider>
			</ConfigProvider>
		</StrictMode>
	);
});
